$(document).ready(function() {
  // Function to update subscription details visibility
  function updateSubscriptionDetails() {
    var subscriptionDetails = $('.rc-selection__root');
    var buyerConsent = $('.ns-buyer-consent');

    if ($('.rc-purchase-option__subscription').is(':checked')) {
      subscriptionDetails.css('display', 'flex');
      buyerConsent.css('display', 'block');
    } else {
      subscriptionDetails.css('display', 'none');
      buyerConsent.css('display', 'none');
    }
  }

  // Attach change event listeners to the radio buttons using event delegation
  $(document).on('change', '.rc-selection__onetime, .rc-purchase-option__subscription', function() {
    updateSubscriptionDetails();
  });

  // Initial check to ensure correct display state on page load
  updateSubscriptionDetails();
});